import { render, staticRenderFns } from "./mps-management.vue?vue&type=template&id=f119aa10&scoped=true&"
import script from "./mps-management.vue?vue&type=script&lang=ts&"
export * from "./mps-management.vue?vue&type=script&lang=ts&"
import style0 from "./mps-management.vue?vue&type=style&index=0&id=f119aa10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f119aa10",
  null
  
)

export default component.exports